export default __webpack_public_path__ + "assets/images/aistudio/views/32671eec8697a14b0178c15b3fde841c.png";